// import { type } from '@testing-library/user-event/dist/type';
import React from 'react'
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';





const img1 =
    "https://www.reliancedigital.in/medias/Apple-MGN63HNA-Laptops-491946461-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNzczNDJ8aW1hZ2UvanBlZ3xpbWFnZXMvaDVhL2gyZC85NDQzMDgzNTgzNTE4LmpwZ3xhYzRiNWIxZGQ2NjNiNWIyYjI0Y2ZkYTZlZWQ3MTFjZTMxYzVmNDBiNmM5Mzk5OTM2OGVkZmExMjMyYjIxNDQ4";
const img2 =
    "https://rukminim2.flixcart.com/image/612/612/xif0q/shoe/n/5/t/9-iq6767-10-reebok-black-white-original-imagvgcaysjan9ae.jpeg?q=70";

const img3=
"https://m.media-amazon.com/images/I/31VjlrbE3bL._SY445_SX342_QL70_FMwebp_.jpg";

const img4="https://m.media-amazon.com/images/I/31eHrGoFNRL._SX300_SY300_QL70_FMwebp_.jpg";

const img5="https://m.media-amazon.com/images/I/41jJtitW+KL._SY300_SX300_.jpg";
const img6="https://m.media-amazon.com/images/I/41Ew6Dv-pJL._SX300_SY300_QL70_FMwebp_.jpg";
const img7="https://m.media-amazon.com/images/I/41+ZNe8jgsL._SY300_SX300_.jpg";
const img8="https://m.media-amazon.com/images/I/4172VWuj+cL._SY300_SX300_.jpg";
const img9="https://m.media-amazon.com/images/I/31BTnXeDegL._SY445_SX342_.jpg";
const img10="https://m.media-amazon.com/images/I/71x4rLhMkML._SY879_.jpg";
const img11="https://m.media-amazon.com/images/I/31XUHqBG5qL._SX300_SY300_QL70_FMwebp_.jpg";
const img12="https://rukminim2.flixcart.com/image/832/832/xif0q/sunglass/o/g/w/m-149044-vincent-chase-original-imahyqdygkamywkw.jpeg?q=70&crop=false";

const Home = () => {
    const productlist = [
        {
            name: "mac book",
            price: 12000,
            imgSrc: img1,
            id: "najkchauc",
        },
        {
            name: "shoes",
            price: 240,
            imgSrc: img2,
            id: "najkchagfguc",
        },
        {
            name: "iPhone",
            price: 150000,
            imgSrc: img3,
            id: "najkchagfguc",
        },
        {
            name: "Laptop",
            price: 200000,
            imgSrc: img4,
            id: "najkchagfguc",
        },
        {
            name: "Watch",
            price: 24000,
            imgSrc: img5,
            id: "najkchagfguc",
        },
        {
            name: "Keyboard",
            price: 1500,
            imgSrc: img6,
            id: "najkchagfguc",
        },
        {
            name: "Mouse",
            price: 2000,
            imgSrc: img7,
            id: "najkchagfguc",
        },
        {
            name: "Helmet",
            price: 5500,
            imgSrc: img8,
            id: "najkchagfguc",
        },
        {
            name: "Trouser",
            price: 2500,
            imgSrc: img9,
            id: "najkchagfguc",
        },
        {
            name: "T-shirt",
            price: 3000,
            imgSrc: img10,
            id: "najkchagfguc",
        },
        {
            name: "Realme Buds",
            price: 5000,
            imgSrc: img11,
            id: "najkchagfguc",
        },
        {
            name: "Sunrise Goggle",
            price: 1000,
            imgSrc: img12,
            id: "najkchagfguc",
        },
    ];


    const dispatch=useDispatch();
    const addToCartHandler  = (options) => {
       console.log(options);
        dispatch({type:"addToCart",payload:options});
        dispatch({ type:"calculateprice"});
        toast.success("Added to Cart");
    };
    return (

        <div className='home'>
            {productlist.map((i) => (
                    <Productcard
                     key={i.id} 
                    imgSrc={i.imgSrc}
                     name={i.name} 
                    price={i.price}
                     id={i.id} 
                    handler={addToCartHandler}
                    />
                ))}
        </div>
    );
};

const Productcard = ({ name, id, price, handler, imgSrc }) => (
    <div className="productcard">
        <img src={imgSrc} alt={name} /> 
        <p>{name}</p>
        <h4>${price}</h4>
        <button onClick={() => handler({ name, price, id, quantity: 1, imgSrc })}>Add to cart</button>
    </div>
);


export default Home;
